import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { FreelancerPage } from "@/features/freelancers/FreelancerPage";

const search = z.object({ tab: z.enum(["overview", "work", "payouts", "history"]).optional() });

export const Route = createFileRoute("/_app/freelancers/$freelancer")({
  validateSearch: search,
  component: Page,
});

function Page() {
  const { freelancer } = Route.useParams();
  return <FreelancerPage id={freelancer} search={Route.useSearch()} />;
}
